// extracted by mini-css-extract-plugin
module.exports = {"refreshBtn":"Loading_refreshBtn__2RMGe"};